export default __webpack_public_path__ + "static/danilsa fernandez-9d79b2e42bd7ba651e5da0057a570eeb.png";